import { baseRequest } from '../../common/request.js';
export const getQuerySuggestRequestOptions = (req) => {
    return {
        ...baseRequest(req, 'search/querySuggest'),
        requestParams: prepareRequestParams(req),
    };
};
const prepareRequestParams = (req) => {
    const { trackingId, query, clientId, context, language, country, currency } = req;
    return {
        trackingId,
        query,
        clientId,
        context,
        language,
        country,
        currency,
    };
};
